import logger from 'redux-logger'
import { Middleware, Dispatch, Action } from 'redux'
import {
  recordReduxAction,
  setReduxTelemetryStateGetter,
} from './telemetryContext'

let reduxTelemetryGetterRegistered = false

const telemetryReduxMiddleware: Middleware =
  storeApi => next => (action: unknown) => {
    if (!reduxTelemetryGetterRegistered) {
      setReduxTelemetryStateGetter(() => storeApi.getState())
      reduxTelemetryGetterRegistered = true
    }
    recordReduxAction(action as { type?: unknown; meta?: unknown })
    return next(action as never)
  }

export const getMiddlewares = () => {
  const productionMiddlewares = [] as unknown as Array<
    Middleware<unknown, unknown, Dispatch<Action>>
  >

  if (['production', 'test'].includes(process.env.NODE_ENV || '')) {
    return productionMiddlewares.concat(telemetryReduxMiddleware)
  } else {
    const devMiddlewares = [telemetryReduxMiddleware, logger]
    return productionMiddlewares.concat(...devMiddlewares)
  }
}
